import { render, staticRenderFns } from "./soporteGeneral.vue?vue&type=template&id=2813d145&scoped=true"
import script from "./soporteGeneral.vue?vue&type=script&lang=js"
export * from "./soporteGeneral.vue?vue&type=script&lang=js"
import style0 from "./soporteGeneral.vue?vue&type=style&index=0&id=2813d145&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813d145",
  null
  
)

export default component.exports